const UNITS_PROPERTIES = {
  //getUnit
  UNITS_UNIT: 'UNITS_UNIT',
  //getRooms
  UNITS_UNIT_ROOMS: 'UNITS_UNIT_ROOMS',
  //getSettings
  UNITS_UNIT_SETTINGS: 'UNITS_UNIT_SETTINGS',
  //getUnitsPublishingSettings
  UNITS_PUBLISHING_SETTINGS: 'UNITS_PUBLISHING_SETTINGS',
  //delete unit partner discount
  UNITS_UNIT_DELETE_PARTNER_DISCOUNT: 'UNITS_UNIT_DELETE_PARTNER_DISCOUNT',
  //uisert unit partner discount
  UNITS_UNIT_INSERT_PARTNER_DISCOUNT: 'UNITS_UNIT_INSERT_PARTNER_DISCOUNT',
  //uisert unit partner discount
  UNITS_UNIT_UPDATE_PARTNER_DISCOUNT: 'UNITS_UNIT_UPDATE_PARTNER_DISCOUNT',
  //getUnitPartnerDiscount
  UNITS_UNIT_PARTNER_DISCOUNT: 'UNITS_UNIT_PARTNER_DISCOUNT',
  //delete unit season
  UNITS_UNIT_DELETE_UNIT_SEASON: 'UNITS_UNIT_DELETE_UNIT_SEASON',
  //getUnitComments
  UNITS_UNIT_COMMENTS: 'UNITS_UNIT_COMMENTS',
};

export default UNITS_PROPERTIES;
